   <div class="full-height full-width">
      <div style="text-align: end; padding: 10px;" class="full-width" (click)="close()">
      <span style="border-radius: 50%; background: lightgrey;" class="material-symbols-outlined">
close
</span>
    </div>
    <p class="text-title"> {{'POI.ADD' | translate}} </p>

    <div class="poi-icon-container">
      <span class="material-symbols-outlined poi-icon">add_location_alt</span>
    </div>

    <div style="margin-bottom: 15px;">
       <ion-select
          [ngClass]="{'custom': !isIOS, 'custom-ios': isIOS}"
          legacy="true"
          fill="outline"
          [(ngModel)]="type"
          okText="{{'OK'|translate}}"
          cancelText="{{'CANCEL'|translate}}"
          label="{{'TYPE'|translate}} *"
          labelPlacement="floating"
        >
          <ion-select-option *ngFor="let type_option of types" [value]="type_option.value"
            >{{ type_option.label }}</ion-select-option
          >
        </ion-select>
    </div>

    <div style="margin-bottom: 15px;">
    <ion-input 
    [ngClass]="{'custom': !isIOS, 'custom-ios': isIOS}"
    [(ngModel)]="comment"
    label="{{'COMMENT'|translate}}" 
    label-placement="floating" fill="outline" ></ion-input>
    </div>

      <div style="text-align: center;">
        <ion-button class="save-button" size="small" color="primary"
        (click)="onOkClick()"
        [disabled]="!type" 
          >{{'SAVE'|translate}}</ion-button
        >
    </div>

   </div>
